import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { NstiStockCategoryContainerModel } from '../../../../../../models/aggregates/erp/non-stock-and-trade-in/nsti-stock-category-container.model';
@Injectable({
  providedIn: 'root'
})
export class NstiStockCategoryService extends BaseApiTemplateService<NstiStockCategoryContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'non-stock-trade-in/stock-categories/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'non-stock-trade-in/stock-categories/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'non-stock-trade-in/stock-categories/backoffice-ep';
    this.httpClient = http;
  }

}
